import { FC } from 'react';
import { Link } from 'react-router-dom';
import { mailto } from '../services/profile';
import FullCvLink from './FullCvLink';

const SiteHeader: FC = () => (
    <header className="site-header">
        <div className="site-header__inner wrap">
            <Link to="/" className="site-brand">
                <span className="site-brand__name">Simon Turner</span>
                <span className="site-brand__sub">Developments</span>
            </Link>
            <nav className="site-nav" aria-label="Primary">
                <Link className="nlink" to="/work">
                    Work
                </Link>
                <Link className="nlink" to="/#about">
                    About
                </Link>
                <Link className="nlink" to="/#experience">
                    Experience
                </Link>
                <FullCvLink className="nlink" />
            </nav>
            <a className="btn btn-primary site-header__cta" href={mailto}>
                Email me
            </a>
        </div>
    </header>
);

export default SiteHeader;
